import { useCallback, useEffect, useState } from 'react';
import { fetchVendors, Vendor } from 'lib/models/vendors';

function useVendors() {
	const [loading, setLoading] = useState<boolean>(true);
	const [vendors, setVendors] = useState<Vendor[]>([]);

	const refetch = useCallback(async () => {
		setLoading(true);
		const response = await fetchVendors();
		setVendors(response);
		setLoading(false);
	}, []);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, vendors, refetch };
}

export default useVendors;
